import { setTrackView, useTracking } from '@vfit/shared/data-access';
import { setTrackLink } from '@vfit/shared/data-access';
import { getUserInfo } from '../../checkoutEnergy.utils';
import { withAnimationDelay } from '../../hoc/withAnimationDelay';
import { getEnergyTagging } from '../../checkoutEnergy.utils';
import { useEnergyCheckout } from '../../../energy.context';

const TaggingComponent = () => {
  const { product } = useEnergyCheckout();
  const tagging = getEnergyTagging(product, 'confirm id');

  const { trackView } = useTracking({
    event: ['checkout_step1.1'],
    event_label: 'verify id',
    opts: tagging?.opts,
    cartProduct: tagging?.trackingProduct,
    pageProduct: tagging?.pageProductsInfo,
    visitorTrackingOpts: getUserInfo(),
  });
  setTrackLink(trackView, 'verify id');
  setTrackView(trackView);

  return null;
};

const TaggingConfirmIdentityCard = withAnimationDelay()(TaggingComponent);

export default TaggingConfirmIdentityCard;

